import WarningMessage from './WarningMessage';

const Cloudflare = {
  WarningMessage,
};

export default Cloudflare;
